import { createGlobalStyle } from 'styled-components'

export const ResetStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  button, link, input[type="submit"] {
    cursor: pointer;
  }

  body {
    font-family: 'Montserrat', sans-serif;
    background-color: ${(props) => props.theme.colors.black};


    @media (max-width: 500px) {
      .scrollbar-thumb {
        width: 4px;
        height: 6px;
      }
      .scrollbar-track {
        background: transparent;
      }
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: ${(props) => props.theme.fontWeights.bold};
  }

  h1 {
    font-size: ${(props) => props.theme.fontSizes.h1};
    line-height: ${(props) => props.theme.lineHeight.h1};
    
  }

  h2 {
    font-size: ${(props) => props.theme.fontSizes.h2};
    line-height: ${(props) => props.theme.lineHeight.h2};
  }

  h3 {
    font-size: ${(props) => props.theme.fontSizes.h3};
    line-height: ${(props) => props.theme.lineHeight.h3};
  }

  h4 {
    font-size: ${(props) => props.theme.fontSizes.h4};
    line-height: ${(props) => props.theme.lineHeight.h4};
  }

  h5 {
    font-size: ${(props) => props.theme.fontSizes.h5};
    line-height: ${(props) => props.theme.lineHeight.h5};
  }

  #rd-row-kyxb55kg {
    background-color: #1b3e51;
  }
  
  #rd-row-kyxb55kg::before {
    content: "";
    display: block;
    z-index: 0;

    position: absolute;
    left: 100px;
    bottom: 100px;

    width: 25%;
    height: 25%;
    max-height: 300px;

    background: radial-gradient(
      100% 50% at 50% 50%,
      #08eddc 30%,
      #000000 100%
    );
    filter: blur(70px);

    @media (max-width: 700px) {
      display: none;
    }
  }

  #rd-column-jt79bwja {
    z-index: 1;
  }

  #rd-button-kyxb55kj {
    background:
        linear-gradient(135deg,#0abaad 0%,#065a5a 100%);
  }

  #rd-box-lk1j1mjc {
    box-shadow:
        0px 0px 18px 0px rgba(8, 237, 220, 0.1),0px 0px 18px 0px rgba(8, 237, 220, 0.5);
    border: none;
  }

  .bricks-form__input {
    &:focus {
      outline: none;
    }
  }
`
